export default __webpack_public_path__ + "static/media/RevenueRecaptureHeader.8b5bd18d.png";